export {default as AdministrativosResumen} from './Encurso'
export {default as AdministrativosEnCursoVer} from './Encurso/Ver'
